/** 環境ファイルツリーのドラッグ対象となる 1 エントリ。 */
export interface EnvironmentEntryDragItem {
	/** 環境ルートからの相対パス ('/' 区切り)。 */
	path: string;
	entryType: "file" | "directory";
	name: string;
}

/** 環境ファイルツリーのエントリ (ファイル / フォルダ) をドラッグするときのペイロード。 */
export interface EnvironmentEntryPayload {
	kind: "environment-entry";
	/** ドラッグするエントリ。複数選択されているエントリをドラッグした場合は、その選択集合を載せる。 */
	entries: readonly EnvironmentEntryDragItem[];
}

/** クラウドの環境の共有ボリュームの行をドラッグするときのペイロード。同じボリュームの中の移動だけに使う。 */
export interface CloudSharedVolumeEntryPayload {
	kind: "cloud-shared-volume-entry";
	volumeId: string;
	/** path はボリュームの根からの相対パス。 */
	entries: readonly EnvironmentEntryDragItem[];
}

/** 右パネルのファイルタブをドラッグするときのペイロード。 */
export interface FileTabPayload {
	kind: "file-tab";
	fileId: string;
	name: string;
}

/**
 * アプリ内でドラッグ可能な全ペイロードの判別共用体。ツリーから別の場所
 * (チャット入力欄など) へのドラッグに対応する際は、ここに variant を追加する。
 */
export type DragPayload = EnvironmentEntryPayload | CloudSharedVolumeEntryPayload | FileTabPayload;

/**
 * dataTransfer に載せる MIME 風キー。dragover 中はブラウザが type 一覧しか公開しないため、
 * アプリ内ロジックはドラッグストアの現在ペイロードを参照し、dataTransfer は
 * クロスウィンドウ／ネイティブ連携のフォールバックとして用いる。
 */
export const DND_MIME = "application/x-izanagi-dnd";
